import { GET_USER_MANUAL_DATA } from "../../constants";

export function getUserManuals(data) {
    return {
        type: GET_USER_MANUAL_DATA,
        data
    };
}